//import "jquery-ui/ui/widgets/datepicker";

export default {
  init() {
    jQuery(function() {
      /*jQuery( "#account_birthdate" ).datepicker({
        dateFormat: "dd/mm/yy",
        dayNames: [ "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi" ],
        dayNamesMin: [ "Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa" ],
        dayNamesShort: [ "Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam" ],
      });*/
      if(jQuery("#cdipickupLocationlabel").length > 0) {
        jQuery('.shipping-address address').html(jQuery("#cdipickupLocationlabel").html().replace(/\b(\d{5})\b/, '<br/>$1').replace('=&gt;', '<br/>').replace('--', '').replace('Point de retrait :', ''));
        //jQuery("#cdipickupLocationlabel").remove();
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce-account.js